<script>
  import Symbol from '$lib/Symbol.svelte'
  import Html from '$lib/Html.svelte'

  export let icon = 'checkmark'
  export let color = 'red'
  export let row = false
  export let small = false
  export let items = []
</script>

<ul class="list" class:row class:small>
  {#each items as item}
    {@const _icon = item.icon || icon}
    <li class="item">
      {#if _icon}
        <span
          class="icon"
          style:--current-background="rgb(var(--rgb-{color
            ? color.toLowerCase()
            : 'red'}))"
          style:--current-color="#fff">
          <Symbol name={_icon.toLowerCase()} circle size="fill" />
        </span>
      {/if}
      <Html size={small ? 'small' : null}>
        <slot {item} />
      </Html>
    </li>
  {/each}
</ul>

<style>
  .list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .list.small {
    gap: 0.75rem;
  }

  .item {
    display: flex;
    flex-wrap: nowrap;
  }

  @media (min-width: 700px) {
    .list:not(.row) {
      grid-template-columns: 1fr 1fr;
      gap: 2rem;
    }

    .item {
      text-wrap: balance;
    }
  }

  @media (min-width: 1000px) {
    .list:not(.row) {
      grid-template-columns: 1fr 1fr 1fr;
      gap: 2.5rem 4.5rem;
    }
  }

  .item .icon {
    --current-background: rgb(var(--rgb-yellow));
    --current-color: rgb(var(--rgb-text));

    margin-right: 0.6rem;
    margin-top: 0.14rem;
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;
    position: relative;
    top: 0.02rem;
  }

  @media (min-width: 700px) {
    .list:not(.small) .item .icon {
      margin-right: 0.85rem;
      width: 1.5rem;
      height: 1.5rem;
    }
  }
</style>
